module.exports = __webpack_public_path__ + "static/media/iconePix.3988fb32.svg";